import styled, { css } from "styled-components";
import buildColor from "../../_static/ColorPalette";
import { fontNormal } from "../../_static/Typography";

export const Container = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: ${fontNormal};
  font-size: 14px;
  font-weight: 400;
`;

export const Title = styled.p`
  color: ${buildColor("grey", "900")};
`;

export const ListContainer = styled.div`
  margin: 12px 0;
  display: flex;
  flex-direction: column;
`;

export const ListRow = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 8px;
  ${({ lastChild, noMarginBottomLastChild }) =>
    lastChild &&
    noMarginBottomLastChild &&
    css`
      &:last-child {
        margin-bottom: 0;
      }
    `}
`;

export const RowDot = styled.span`
  &::before {
    content: "";
    position: absolute;
    left: 6px;
    top: 6px;
    width: 4px;
    height: 4px;
    color: ${({ isWarning }) =>
      isWarning
        ? `${buildColor("orange", "700")}`
        : `${buildColor("grey", "800")}`};
    background-color: ${({ isWarning }) =>
      isWarning
        ? `${buildColor("orange", "700")}`
        : `${buildColor("grey", "800")}`};
    border-radius: 50%;
  }
`;

export const RowText = styled.p`
  flex: 1;
  margin-left: ${({ hasIcon }) => (hasIcon ? "8px" : "24px")};
  color: ${buildColor("grey", "800")};
  ${({ isSuccess }) => isSuccess && `color: ${buildColor("green", "700")};`}
  ${({ isWarning }) => isWarning && `color: ${buildColor("orange", "700")};`}
`;
